import { useQuery } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { getUserWorkspaceList } from '../../../api/workspaces';
import { Workspace } from '../../../api/workspaces/types';

export function useWorkspaceList<T = Workspace[]>({
  select,
  enabled,
}: { enabled?: boolean; select?: (workspace: Workspace[]) => T } = {}) {
  return useQuery({
    queryKey: workspaceKeys.list(),
    queryFn: getUserWorkspaceList,
    enabled: enabled,
    select: select,
  });
}
